import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=0f4fb4ba&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=0f4fb4ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fb4ba",
  null
  
)

export default component.exports